module.exports = __webpack_public_path__ + "media/images/photo/plans/places/sorakuen-be0029102aef19bfcc39425869a8f8df.png";